import Input from '@anm/components/form/Input';
import { useCallback, ChangeEvent, FC } from 'react';
import { useDispatch } from 'react-redux';

import { PopoverTypeIndexes } from '..';
import { hostedVideoActions } from '../../../../../../../store/modules/hostedVideo';
import { SectionSubTitle } from '../../../../Wrapper';

import { useTextField } from './hooks';

type TextFieldProps = {
  activePopoverType: PopoverTypeIndexes;
};

const TextField: FC<TextFieldProps> = ({ activePopoverType }) => {
  const [
    textFieldTitle,
    textFieldDefaultValue,
    textFieldValue,
    setTextFieldValue
  ] = useTextField(activePopoverType as PopoverTypeIndexes);

  const handleInputChange = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) =>
      setTextFieldValue(target.value),
    []
  );

  const dispatch = useDispatch();

  const handleInputBlur = useCallback(
    () =>
      dispatch(
        hostedVideoActions.updatePopoverEmbed({
          text: textFieldValue || textFieldDefaultValue
        })
      ),
    [textFieldValue, textFieldDefaultValue]
  );

  return (
    <>
      <SectionSubTitle title={textFieldTitle} level={4} />
      <Input
        variant="simple-small"
        value={textFieldValue}
        onBlur={handleInputBlur}
        onChange={handleInputChange}
      />
    </>
  );
};

export default TextField;
